<template>
	<div class="l-container works">
		<div class="recently-project-wrap">
			<h1 class="page-tit">UI/UX</h1>
			<!-- Thumbnail View : s -->
			<div class="view-area">
				<div class="is-active">
					<div class="select-box-wrap">
						<div class="select-box tab">
							<div class="swiper-container tab-swiper">
								<ul class="swiper-wrapper">
									<li class="swiper-slide is-active">
										<a
											href="javascript:;"
											@click="sortingByCategory('All', $event)"
											>All</a
										>
									</li>
									<li class="swiper-slide">
										<a
											href="javascript:;"
											@click="sortingByCategory('Corporation', $event)"
											>Corporation</a
										>
									</li>
									<li class="swiper-slide">
										<a
											href="javascript:;"
											@click="sortingByCategory('e-Commerce', $event)"
											>e-Commerce</a
										>
									</li>
									<li class="swiper-slide">
										<a
											href="javascript:;"
											@click="sortingByCategory('Finance', $event)"
											>Finance</a
										>
									</li>
									<li class="swiper-slide">
										<a
											href="javascript:;"
											@click="sortingByCategory('Travel', $event)"
											>Travel</a
										>
									</li>
									<li class="swiper-slide">
										<a
											href="javascript:;"
											@click="sortingByCategory('System', $event)"
											>System</a
										>
									</li>
									<li class="swiper-slide">
										<a
											href="javascript:;"
											@click="sortingByCategory('Etc', $event)"
											>Etc</a
										>
									</li>
								</ul>
							</div>
						</div>
						<div class="select-box select">
							<a
								href="javascript:;"
								@click="toggleYearSelect"
								class="btn-select"
								:class="{ 'is-active': yearSelectOpen }"
								>연도 선택</a
							>
							<ul class="year-list">
								<li class="is-active">
									<a href="javascript:;" @click="sortingByYear('all', $event)"
										>All</a
									>
								</li>
								<li v-for="year in years" :key="year">	
									<a 
										href="javascript:;"
										@click="sortingByYear(String(year), $event)"
										>{{ year }}</a
									>
								</li>
								<!--<li>
									<a href="javascript:;" @click="sortingByYear('2021', $event)"
										>2021</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2020', $event)"
										>2020</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2019', $event)"
										>2019</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2018', $event)"
										>2018</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2017', $event)"
										>2017</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2016', $event)"
										>2016</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2015', $event)"
										>2015</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2014', $event)"
										>2014</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2013', $event)"
										>2013</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2012', $event)"
										>2012</a
									>
								</li>-->
							</ul>
						</div>
					</div>
					<div class="recently-project" v-if="projectSize">
						<transition-group tag="ul" name="pj-list">
							<li
								v-for="project in projectCurrent"
								:key="project.id"
								v-show="project.show"
								class="pj-list"
								@mouseover="listAnimationEnter($event)"
								@mouseleave="listAnimationLeave($event)"
							>
								<template v-if="'prjUrl' in project">
									<router-link :to="'/uiux/' + project.prjUrl">
										<img :src="project.imgsrc" :alt="project.imgalt" />
										<p class="desc">
											<strong class="tit" v-text="project.prjtitle"></strong>
											<span v-text="project.prjname"></span>
										</p>
									</router-link>
								</template>
								<template v-else>
									<div>
										<p>
											<strong class="tit" v-text="project.prjname"></strong>
											<span v-text="project.prjtitle"></span>
										</p>
										<dl>
											<dt v-text="project.prjyear"></dt>
											<dd class="img">
												<img
													:src="project.imgsrc"
													:alt="project.imgalt"
													v-show="project.imgsrc != undefined"
												/>
											</dd>
										</dl>
									</div>
								</template>
							</li>
						</transition-group>
					</div>
					<div class="message" v-else>해당하는 프로젝트가 없습니다.</div>
				</div>
				<!-- Thumbnail View : e -->
			</div>
		</div>
		<br />
		<router-view></router-view>
	</div>
</template>

<script>
import { store } from "../data/store.js";
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
export default {
	metaInfo: {
		title: "UI/UX",
		meta: [
			{
				vmid: "description",
				name: "description",
				content:
					"제오젠은 이커머스, 금융, 여행업, 시스템, 쇼핑몰, 회사홍보 등 다양한 분야의 UI/UX를 진행합니다.",
			},
		],
	},
	data() {
		return {
			store,
			yearSelectOpen: false,
			yearStart: 2012,
			sortingCondition: {
				category: "all",
				year: "all",
			},
			projectSize: true,
			projectCurrent: [],
			projectStore: [],
		};
	},
	mounted: function () {
		//console.log('mounted')
		this.sortingByQuery();

		// mobile tab menu swiper control
		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var pcwebSwiper;

		var pcWeb = function () {
			if (isSlider) {
				isSlider = false;
				pcwebSwiper = new Swiper(".tab-swiper", {
					slidesPerView: "auto",
					spaceBetween: 20,
					grabCursor: true,
					loop: false,
					slideToClickedSlide: true,
				});
			}
		};

		winW = $window.outerWidth();
		if (winW < 712) {
			pcWeb();
		} else {
			isSlider = true;
		}

		$window.on("resize", function () {
			winW = $window.outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					pcWeb();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					pcwebSwiper.destroy();
				}
			}
		});
	},
	watch: {
		$route(to, from) {
			this.sortingByQuery();
		},
	},
	methods: {
		listAnimationEnter(e) {
			var $this = $(e.currentTarget);
			if (!$this.hasClass("is-animating")) {
				$this.addClass("is-animating");
				var direction, x, y;
				var $desc = $this.find(".desc");
				var w = $this.width();
				var h = $this.height();
				(x = (e.pageX - $this.offset().left - w / 2) * (w > h ? h / w : 1)),
					(y = (e.pageY - $this.offset().top - h / 2) * (h > w ? w / h : 1)),
					(direction =
						Math.round((Math.atan2(y, x) * (180 / Math.PI) + 180) / 90 + 3) %
						4);

				if (direction == 0) {
					$desc.css({ top: -h, left: 0 });
				} else if (direction == 1) {
					$desc.css({ top: 0, left: w });
				} else if (direction == 2) {
					$desc.css({ top: h, left: 0 });
				} else {
					$desc.css({ top: 0, left: -w });
				}
				$this.find(".desc").stop().animate({ top: 0, left: 0 }, 240);
			}
		},
		listAnimationLeave(e) {
			var $this = $(e.currentTarget);
			var option = {};
			var direction, x, y;
			var w = $this.width();
			var h = $this.height();
			(x = (e.pageX - $this.offset().left - w / 2) * (w > h ? h / w : 1)),
				(y = (e.pageY - $this.offset().top - h / 2) * (h > w ? w / h : 1)),
				(direction =
					Math.round((Math.atan2(y, x) * (180 / Math.PI) + 180) / 90 + 3) % 4);

			if (direction == 0) {
				option = { top: -h, left: 0 };
			} else if (direction == 1) {
				option = { top: 0, left: w };
			} else if (direction == 2) {
				option = { top: h, left: 0 };
			} else {
				option = { top: 0, left: -w };
			}
			$this
				.find(".desc")
				.stop()
				.animate(option, 240, function () {
					$this.removeClass("is-animating");
					$(this).css({ top: 0, left: -w });
				});
		},
		sortingByQuery() {
			//init
			//this.projectCurrent = this.projectStore;
			this.projectCurrent = this.projectStore.slice().reverse();

			//Query에 따라 Data 저장
			this.sortingCondition.category =
				this.$route.query.category != undefined
					? this.$route.query.category
					: "all";
			this.sortingCondition.year =
				this.$route.query.year != undefined ? this.$route.query.year : "all";

			let category = this.sortingCondition.category;
			let year = this.sortingCondition.year;

			//Data에 따라 projectCurrent 저장
			if (category != "all") {
				if (year != "all") {
					this.projectCurrent.forEach(function (v) {
						if (
							v.prjyear.toLowerCase() == year &&
							v.category.toLowerCase() == category
						) {
							v.show = true;
						} else {
							v.show = false;
						}
					});
					// this.projectCurrent = this.store.projects.filter(
					// 	(v) =>
					// 		v.prjyear.toLowerCase() == this.sortingCondition.year &&
					// 		v.category.toLowerCase() == this.sortingCondition.category
					// );
				} else {
					this.projectCurrent.forEach(function (v) {
						if (v.category.toLowerCase() == category) {
							v.show = true;
						} else {
							v.show = false;
						}
					});
					// this.projectCurrent = this.store.projects.filter(
					// 	(v) => v.category.toLowerCase() == this.sortingCondition.category
					// );
				}
			} else {
				if (year != "all") {
					this.projectCurrent.forEach(function (v) {
						if (v.prjyear.toLowerCase() == year) {
							v.show = true;
						} else {
							v.show = false;
						}
					});
					// this.projectCurrent = this.store.projects.filter(
					// 	(v) => v.prjyear.toLowerCase() == this.sortingCondition.year
					// );
				} else {
					this.projectCurrent.forEach(function (v) {
						v.show = true;
					});
				}
			}

			//조건에 맞는 프로젝트 수
			let showNum = this.projectCurrent.filter((v) => v.show == true).length;
			this.projectSize = showNum != 0 ? true : false;

			this.changeQuery(category, year);
		},
		//Query에 따라 RouterPush
		changeQuery(category, year) {
			category = category != undefined ? category : "all";
			year = year != undefined ? year : "all";

			if (category != "all") {
				if (year != "all") {
					this.$router
						.push(`/uiux?category=${category}&year=${year}`)
						.catch(() => {});
				} else {
					this.$router.push(`/uiux?category=${category}`).catch(() => {});
				}
			} else {
				if (year != "all") {
					this.$router.push(`/uiux?year=${year}`).catch(() => {});
				} else {
					this.$router.push(`/uiux`).catch(() => {});
				}
			}
			this.categorySelect(category);
			this.yearSelect(year);
		},
		sortingByCategory(category, event) {
			category = category.toLowerCase();
			this.sortingCondition.category = category;
			this.changeQuery(category, this.sortingCondition.year);

			//Data 변경 적용
			this.sortingByQuery();

			//activation 동작
			$(event.target)
				.parent(".swiper-slide")
				.addClass("is-active")
				.siblings(".swiper-slide")
				.removeClass("is-active");
		},
		sortingByYear(year, event) {
			year = year.toLowerCase();
			this.sortingCondition.year = year;
			this.changeQuery(this.sortingCondition.category, year);

			//Data 변경 적용
			this.sortingByQuery();

			//SelectBox 닫을때 이루어지는 동작
			if (year != "all") {
				event.currentTarget.closest(".select").firstChild.innerText = year;
			} else {
				this.projectCurrent = this.store.projects;
				//this.projectCurrent = this.projectStore.slice().reverse();
				event.currentTarget.closest(".select").firstChild.innerText =
					"연도 선택";
			}
			this.yearSelectOpen = false;
		},
		categorySelect(category) {
			$(".select-box-wrap .tab")
				.find(".swiper-slide")
				.each(function () {
					if ($(this).children("a").text().toLowerCase() == category) {
						$(this).addClass("is-active");
					} else {
						$(this).removeClass("is-active");
					}
				});
		},
		yearSelect(year) {
			let text;
			if (year != "all") {
				text = year;
			} else {
				text = "연도 선택";
			}
			document.querySelector(".select-box-wrap .btn-select").innerText = text;
		},
		toggleYearSelect() {
			this.yearSelectOpen = !this.yearSelectOpen;
		},
	},
	created() {
		//init (Show 키 생성 default: true)
		this.store.projects.forEach(function (v) {
			v.show = true;
		});
		this.projectStore = this.store.projects;
	},
	computed: {
		years() {
			const currentYear = new Date().getFullYear()-1
			return Array.from(
				{ length: currentYear - this.yearStart + 1 },
				(_, i) => currentYear - i
			)
		}
	}
};
</script>

<style scoped>
.pj-list {
	overflow: hidden;
}
.pj-list > a,
.pj-list > div {
	display: block;
	transition: opacity 0.6s, transform 0.6s;
}

.pj-list-enter > a,
.pj-list-enter > div,
.pj-list-leave-to > a,
.pj-list-leave-to > div {
	opacity: 0;
	transform: translateY(60px);
}
.pj-list-enter-to > a,
.pj-list-enter-to > div {
	opacity: 1;
	transform: translateY(0);
}
.pj-list-leave-active > a,
.pj-list-leave-active > div {
	transition: opacity 0.6s 0.6s, transform 0.6s 0.6s;
}
</style>



// WEBPACK FOOTER //
// src/components/XgWorks.vue